export const PRICE_BREAKDOWN_TESTID = 'price-breakdown';
export const PRICE_BREAKDOWN_ADDED_TESTID = 'price-breakdown-added';
export const PRICE_BREAKDOWN_REMOVED_TESTID = 'price-breakdown-removed';
export const PRICE_BREAKDOWN_QUANTITY_TESTID = 'price-breakdown-quantity';
